import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import '../css/history.css';
import bgImage from "../assets/background-4.jpg";

export default function Terms() {
  return (
    <>
      <Navbar />
      <PageHeader title="Terms of Use" path="/terms" name="Terms of Use" bgImage={bgImage} />
      <div className="history-page container-xxl py-5">
        <div className="container">
          <div className="history-intro">
            <h1>Official Terms of Use</h1>
            <p className="lead">
              These Terms govern how you may use the Democratic Republic of the Yoruba (D.R.Y) official website and
              online services. Please read them carefully.
            </p>
          </div>

          <div className="history-section">
            <h3>1. Acceptance of Terms</h3>
            <p>
              By accessing or using this website, you agree to follow these Terms and all applicable laws of the D.R.Y.
              If you do not agree, you should stop using the website immediately.
            </p>
            <ul>
              <li>Use of the site means you accept the latest published version of these Terms.</li>
              <li>If you are using the site on behalf of an organisation, you confirm you are authorised to do so.</li>
              <li>You are responsible for ensuring that anyone using the site through your device understands these Terms.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>2. Permitted Use</h3>
            <p>
              The website exists to inform citizens, residents and partners about national programmes, public services,
              history, culture and governance.
            </p>
            <ul>
              <li>Browse, read and download public information for personal or educational use.</li>
              <li>Share links to official pages with clear attribution to the D.R.Y.</li>
              <li>Use forms and resources only for their stated official purpose.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>3. Prohibited Conduct</h3>
            <p>
              To protect all users and national infrastructure, certain behaviour is not allowed on this website.
            </p>
            <ul>
              <li>Attempting to gain unauthorised access to systems, accounts or data.</li>
              <li>Uploading or spreading harmful code, spam or offensive material.</li>
              <li>Scraping, harvesting or re‑using data in ways that break privacy or security rules.</li>
              <li>Impersonating government officials or other users.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>4. Intellectual Property</h3>
            <p>
              Unless stated otherwise, the content on this site belongs to the Democratic Republic of the Yoruba.
            </p>
            <ul>
              <li>Logos, emblems, photographs, videos and written content are protected material.</li>
              <li>Non‑commercial use with proper credit is usually allowed, provided content is not altered or misused.</li>
              <li>Commercial or large‑scale re‑use requires written permission from the relevant authority.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>5. Disclaimers and Liability</h3>
            <p>
              We work to keep information accurate and the website available, but some limits apply.
            </p>
            <ul>
              <li>Information is provided for general guidance and may change without prior notice.</li>
              <li>No guarantee is given that the site will be free from interruptions, errors or security risks.</li>
              <li>The D.R.Y is not responsible for loss or damage arising from improper or unauthorised use of the site.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>6. Changes to These Terms</h3>
            <p>
              From time to time, these Terms may be updated to reflect new laws, policies or digital services.
            </p>
            <ul>
              <li>The “Terms of Use” page always shows the latest version.</li>
              <li>Important changes may also be highlighted through notices on the homepage or official channels.</li>
              <li>Continuing to use the website after changes means you accept the updated Terms.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>7. Contact and Feedback</h3>
            <p>
              Your feedback helps improve this digital gateway for the Yoruba people and friends of the D.R.Y.
            </p>
            <ul>
              <li>Use the contact information in the footer for questions about these Terms.</li>
              <li>Report any security concern or misuse of the site immediately.</li>
              <li>Suggestions for clearer communication or improved access are always welcome.</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}
